import type { DataResponse } from '@/types';
import type { SearchResponse, SearchResultType } from '@/types/search';
import type { AxiosInstance, AxiosResponse, GenericAbortSignal } from 'axios';

class SearchService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    /**
     * Global search across all domains. Pass `types` to restrict the searched
     * domains and `signal` to cancel a stale request when a newer query starts.
     */
    search(
        query: string,
        types: SearchResultType[] = [],
        limit?: number,
        signal?: GenericAbortSignal,
    ): Promise<AxiosResponse<DataResponse<SearchResponse>>> {
        return this.apiService.get('/api/search', {
            params: {
                q: query,
                ...(types.length ? { types: types.join(',') } : {}),
                ...(limit ? { limit } : {}),
            },
            signal,
        });
    }
}

export default SearchService;
